import { Target, ShieldCheck, Leaf, MessageSquare, Timer } from "lucide-react";

const WhyChooseUs = () => {
    const features = [
        {
            icon: <Target size={40} className="wcu-hob-icon" />,
            title: "Act on Root Cause of the Problem",
            desc: "We treat the root cause of the problem, not just the symptoms, for long-lasting results."
        },
        {
            icon: <ShieldCheck size={40} className="wcu-hob-icon" />,
            title: "Safety First Approach",
            desc: "Every treatment is designed keeping the safety of your family and staff as the top priority."
        },
        {
            icon: <Leaf size={40} className="wcu-hob-icon" />,
            title: "Best In Class Environmentally Safe Active Ingredients",
            desc: "We use environmentally safe active ingredients that deliver guaranteed results."
        },
        {
            icon: <MessageSquare size={40} className="wcu-hob-icon" />,
            title: "Explain Pre and Post Service Requisites to Customer",
            desc: "We explain pre and post service requisites so you always know what to expect."
        },
        {
            icon: <Timer size={40} className="wcu-hob-icon" />,
            title: "Quick Resolution of Your Query",
            desc: "We ensure quick resolution of your every query, promptly and professionally."
        }
    ];

    return (
        <section className="wcu-hob-section">
            <div className="wcu-hob-container">
                <h2 className="wcu-hob-title">Why Choose Spiracle</h2>
                <p className="wcu-hob-subtitle">Eco-friendly, professional and cost-effective pest control in Mumbai</p>
                <div className="wcu-hob-grid">
                    {features.map((item, index) => (
                        <div className="wcu-hob-card" key={index}>
                            <div className="wcu-hob-icon-wrapper">{item.icon}</div>
                            <h3 className="wcu-hob-card-title">{item.title}</h3>
                            <p className="wcu-hob-card-desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
